import { QueryClient } from '@tanstack/react-query'

/**
 * Single QueryClient instance shared by the React provider (index.tsx), the router context (router.tsx)
 * and the out-of-React tRPC proxy (client.ts → trpcLoader). They MUST be the same instance so that data
 * prefetched in a route loader is found in cache by the component's useSuspenseQuery.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: 0,
    },
    mutations: {
      gcTime: 0,
    },
  },
})
